import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <div 
      className="footer wow fadeIn" 
      data-wow-delay="0.3s"
      style={{
        backgroundImage: 'url("/img/Aboutus_New.png")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative'
      }}
    >
      <div className="footer-overlay"></div>
      <div className="container" style={{ position: 'relative', zIndex: 1 }}>
        <div className="row">
          {/* India Office */}
          <div className="col-md-6 col-lg-3">
            <div className="footer-contact">
              <h2>India Office</h2>
              <h6>Mikan Engineering and Construction Pvt Ltd</h6>
              <p>
                <i className="fa fa-map-marker-alt"></i>
                Door No.2/165/B, Mikan Complex, Thenkaiprai Road, Chithanthopu, India 629 810
              </p>
              <p><i className="fa fa-phone-alt"></i>+91 0465 2207603</p>
              <p><i className="fa fa-envelope"></i>sales@mikan-groups.com</p>
              <div className="footer-social">
                <a href="#"><i className="fab fa-twitter"></i></a>
                <a href="#"><i className="fab fa-facebook-f"></i></a>
                <a href="#"><i className="fab fa-linkedin-in"></i></a>
                <a href="#"><i className="fab fa-instagram"></i></a>
                <a href="#"><i className="fab fa-youtube"></i></a>
              </div>
            </div>
          </div>

          {/* Singapore Office */}
          <div className="col-md-6 col-lg-3">
            <div className="footer-contact">
              <h2>Singapore Office</h2>
              <h6>Mikan Engineering and Construction Pvt Ltd</h6>
              <p>
                <i className="fa fa-map-marker-alt"></i>
                2 KALLANG AVENUE, #08-16, CT HUB, SINGAPORE-339 407
              </p>
              <p><i className="fa fa-phone-alt"></i>+65 90625963</p>
              <p><i className="fa fa-envelope"></i>sales@mikan-groups.com</p>
            </div>
          </div>

          {/* Ireland Office */}
          <div className="col-md-6 col-lg-3">
            <div className="footer-contact">
              <h2>Ireland Office</h2>
              <h6>Mikan Engineering Limited</h6>
              <p>
                <i className="fa fa-map-marker-alt"></i>
                32 ,Boughlone Way, Bellingham, Portlaoise, Co. Laois, R32 H7DT, Ireland.
              </p>
              <p><i className="fa fa-phone-alt"></i>+353 896047510</p>
              <p><i className="fa fa-envelope"></i>sales@mikan-groups.com</p>
            </div>
          </div>

          {/* Useful Pages */}
          <div className="col-md-6 col-lg-3">
            <div className="footer-link">
              <h2>Useful Pages</h2>
              <Link to="/about">About Us</Link>
              <Link to="/contact">Contact Us</Link>
              <Link to="/projects">Projects</Link>
              <Link to="/testimonial">Testimonial</Link>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Menu */}
      <div className="container footer-menu">
        <div className="f-menu">
          <Link to="/terms">Terms of use</Link>
          <Link to="/privacy">Privacy policy</Link>
          <Link to="/cookies">Cookies</Link>
          <Link to="/help">Help</Link>
          <Link to="/faqs">FQAs</Link>
        </div>
      </div>

      {/* Copyright */}
      <div className="container copyright">
        <div className="row">
          <div className="col-md-6">
            <p>&copy; <a href="#">MIKAN GROUPS</a>, All Right Reserved.</p>
          </div>
          <div className="col-md-6">
            <p>Designed By <a href="https://webdesignerpro-sbs.netlify.app/">SBSMANIAN</a></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;